import { useState, useRef } from "react";
import Slider from "react-slick";
import "./plan-list-carousel.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomPrevArrow, CustomNextArrow } from "./arrow";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import { getPlanDetails, logSelectedPlanInfo } from "../../api/requests";
import LoadingDots from "../loadingDots";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import findStep from "../../screens/bot/stepModules/findStep";
import addMoneyMask from "../../utils/addMoneyMask";
import BotButton from "../bot-button";
import CategoryGeneric from "../../assets/images/category-generic.svg";
// import sendTag from "../../utils/sendTag";
// import { grupoSituacao } from "../../utils/constants";
import { planoNome, tipoPlanoNomeCased } from "../../utils/constants";
import getMycoins from "../../utils/getMycoins";
import CarouselPlanItem from "./components/carouselPlanItem";
import CardSimulateAgain from "./components/cardSimulateAgain";
import PlanCard from "./components/planCard";

const PlanListCarousel = ({ options }) => {
  let sliderRef = useRef(null);
  let cardRef = useRef(null);

  const setMessages = useBotControlStore((state) => state.setMessages);
  const { setCurrentStep, isBotLoading } = useBotControlStore((state) => state);
  const { setIsSimulateAgain } = useUserStore((state) => state);
  const selectedTipoPlano = useConsorcioStore(
    (state) => state.selectedPlano.nome
  );
  const selectedplano = useConsorcioStore((state) => state.selectedPlano);
  const hasDesconto = useInitialConfigStore((state) => state.desconto);
  const fakeLoad = useInitialConfigStore((state) => state.fakeLoad);

  const [activeSlide, setActiveSlide] = useState(0);
  const [selectedPlanID, setSelectedPlanID] = useState(null);
  const [selectedBemID, setSelectedBemID] = useState(null);

  const isMycoins = !!getMycoins();

  const isSimularNovamenteCard =
    options &&
    options[activeSlide] &&
    options[activeSlide].planoCardType === "simular-novamente";

  const isSelectedCard =
    options &&
    options[activeSlide] &&
    options[activeSlide].planosTipos
      .map((plano) => plano.planoID)
      .includes(selectedPlanID) &&
    options[activeSlide].planosTipos
      .map((plano) => plano.bemId)
      .includes(selectedBemID);

  const selectedOptionIndex = options
    .map((option) =>
      option.planosTipos.map((plano) => ({
        planoID: plano.planoID,
        bemId: plano.bemId,
      }))
    )
    .findIndex((plano) =>
      plano.some(
        (plano) =>
          plano.planoID === selectedPlanID && plano.bemId === selectedBemID
      )
    );

  const updateCheckStatus = (planoID, bemId) => {
    setSelectedPlanID(planoID);
    setSelectedBemID(bemId);

    const selectedOption = options
      .filter((option) =>
        option.planosTipos.map((plano) => plano.planoID).includes(planoID)
      )
      .filter((option) =>
        option.planosTipos.map((plano) => plano.bemId).includes(bemId)
      )[0];

    const userSelectedPlan = options
      .map((plan) => plan.planosTipos)
      .flat()
      .find((plan) => plan.planoID === planoID && plan.bemId === bemId);

    const selectedPlano = {
      nome: userSelectedPlan.name,
      planoIndex: 0,
      planoID: userSelectedPlan.planoID,
      bemID: userSelectedPlan.bemId,
      bemNome: userSelectedPlan.bemNome,
      bemCredito: selectedOption.bemValor,
      planoMeses: selectedOption.planoMeses,
      planoValorParcela: userSelectedPlan.valorParcela,
      planoValorPagamento: userSelectedPlan.valorParcelaPrimeiroPagto,
      labelPlano: "",
      imagemUrlPlano: "",
      exibirTextoResolucao285: userSelectedPlan.exibirTextoResolucao285,
      dataAssembleia: userSelectedPlan.dataProximaAssembleia,
      tipoPlanoID: userSelectedPlan.tipoPlanoID,
    };

    useConsorcioStore.setState({
      selectedPlano,
    });

    setConsorcioStore(planoNome[selectedPlano.nome], "tipoPlano");

    if (isMycoins) {
      if (selectedPlano.nome === tipoPlanoNomeCased.CREDITO_PAGAMETADE) {
        useInitialConfigStore.setState({
          empresaId: 99,
          compraId: 173,
        });
      }

      if (selectedPlano.nome === tipoPlanoNomeCased.CREDITO_INTEGRAL) {
        useInitialConfigStore.setState({
          empresaId: 58,
          compraId: 130,
        });
      }
    }
  };

  const setConsorcioStore = useConsorcioStore(
    (state) => state.setConsorcioStore
  );

  const shouldBeFullHeight = (receivedOptions) => {
    const planTipes = receivedOptions.map((option) => option.planosTipos);
    return !planTipes.some((plan) => plan.length > 1);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
    ],
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    beforeChange: (current, next) => setActiveSlide(next),
  };

  const handleGetPlanDetails = async () => {
    setMessages({
      id: "selected-plan",
      sender: "user",
      text: `<b>${addMoneyMask(selectedplano.bemCredito)}</b></br>em ${
        selectedplano.planoMeses
      } parcelas</br>de ${addMoneyMask(selectedplano.planoValorParcela)}`,
    });

    setLoadingMessage();

    getPlanDetails()
      .then((planDetails) => {
        const { data } = planDetails.data;

        if (data.titulo && data.taxaAdmTotal) {
          setConsorcioStore(data, "fetchedPlanDetails");
        }

        if (window && window.planos_bot && window.planos_bot.vitrine) {
          window.planos_bot.plano_selecionado =
            window.planos_bot.vitrine.filter(
              (plano) => plano.plano_id === String(data.planoID)
            )[0];

          window.dataLayer.push({
            event: "Plano Selecionado",
          });
        }

        setTimeout(() => {
          removeLoadingMessage();

          if (hasDesconto) {
            setCurrentStep(findStep("parcela-desconto-mensagem").index);
          } else {
            setCurrentStep(findStep("proposal-confirm-infos").index);
          }
        }, fakeLoad);
      })
      .catch((error) => {
        console.log("error --->", error);
        setCurrentStep(findStep("error-general").index);
        removeLoadingMessage();
      });
  };

  const handleSetButtonText = () => {
    if (isSimularNovamenteCard) {
      return "SIMULAR NOVAMENTE";
    }

    if (isSelectedCard || !selectedPlanID) {
      return "CONTINUAR";
    }

    if (!isSelectedCard) {
      return "VER MINHA SELEÇÃO";
    }

    return "CONTINUAR";
  };

  const handleClickButton = () => {
    logSelectedPlanInfo().catch((_) => {});
    if (isSimularNovamenteCard) {
      setIsSimulateAgain(true);
      setCurrentStep(findStep("lead-credit-value").index);
      return;
    }

    if (!isSimularNovamenteCard && !isSelectedCard) {
      sliderRef.slickGoTo(selectedOptionIndex);
      return;
    }

    handleGetPlanDetails();
  };

  const handleSetButtonStyle = () => {
    if (
      options &&
      options[activeSlide] &&
      options[activeSlide].planoCardType !== "simular-novamente" &&
      !isSelectedCard &&
      selectedPlanID !== null
    ) {
      return "outlined";
    }
  };

  return (
    <div className="carousel-plan-container">
      {options.length && !isBotLoading ? (
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {options.map((plan, index) => {
            return (
              <CarouselPlanItem key={`plan-${index}`}>
                {plan.planoCardType === "simular-novamente" ? (
                  <CardSimulateAgain
                    cardRef={cardRef}
                    activeSlide={activeSlide}
                    index={index}
                    options={options}
                    CategoryGeneric={CategoryGeneric}
                    shouldBeFullHeight={shouldBeFullHeight}
                  />
                ) : (
                  <PlanCard
                    activeSlide={activeSlide}
                    index={index}
                    plan={plan}
                    selectedPlanID={selectedPlanID}
                    selectedBemID={selectedBemID}
                    shouldBeFullHeight={shouldBeFullHeight}
                    options={options}
                    updateCheckStatus={updateCheckStatus}
                  />
                )}
              </CarouselPlanItem>
            );
          })}
        </Slider>
      ) : (
        <div className="carousel-loading">
          <LoadingDots size="small" color="primary" />
        </div>
      )}
      <div className="carousel-buttons">
        <BotButton
          style={handleSetButtonStyle()}
          onClick={() => {
            handleClickButton();
          }}
          text={handleSetButtonText()}
          enabled={isSimularNovamenteCard || isSelectedCard || !!selectedPlanID}
        />
      </div>
    </div>
  );
};

export default PlanListCarousel;
